<script lang="ts" setup>
import { DefaultButton } from '@hantecmarket/hantec-ui-widget'
import { computed } from 'vue'

import { defaultActiveButtonsProps } from '@/components/ActiveButtons/ActiveButtons.constants'
import { resolveButterUrl, resolveRouteName } from '@/utils/utils'

import type {
  ActionButton,
  ActiveButtonsProps
} from '@/components/ActiveButtons/ActiveButtons.types'

const props = withDefaults(defineProps<ActiveButtonsProps>(), defaultActiveButtonsProps as any)
const leftRoute = computed(() => (props.leftButton as ActionButton)?.routeName)
const rightRoute = computed(() => (props.rightButton as ActionButton)?.routeName)
const leftButtonLink = computed(() =>
  leftRoute.value
    ? resolveRouteName(leftRoute.value)
    : resolveButterUrl((props.leftButton as any)?.href)
)

const rightButtonLink = computed(() =>
  rightRoute.value
    ? resolveRouteName(rightRoute.value)
    : resolveButterUrl((props.rightButton as any)?.href)
)
</script>

<template>
  <div
    :class="{
      'justify-center': position === 'center',
      'justify-start': position === 'left',
      'justify-end': position === 'right'
    }"
    class="flex z-10 relative lg:flex-row gap-[10px] lg:gap-0 flex-col w-full mt-[40px]"
  >
    <DefaultButton
      v-if="leftButton"
      :href="leftButtonLink"
      class="lg:px-8 py-4 flex items-center button text-white rounded-1.5 leading-normal font-bold h-12.5 justify-center bg-red-150"
    >
      {{ leftButton.title }}
    </DefaultButton>
    <DefaultButton
      v-if="rightButton && !onlyLeftButton"
      :class="{
        'border-white text-white': mode === 'dark',
        'border-black text-black': mode === 'light'
      }"
      :href="rightButtonLink"
      class="lg:px-[60px] py-4 flex items-center button rounded-1.5 leading-normal border-[1px] font-bold h-12.5 lg:ml-[10px] justify-center bg-transparent"
    >
      {{ rightButton.title }}
    </DefaultButton>
  </div>
</template>

<style lang="sass" scoped></style>
